<div class="modal-header modal-header-custom">
    <div class="flex justify-content-space-between pt-2">
        <span class="fw-bold title-modal-detail fz-14-px">
            {{ 'rollCall.lblViewRegister' | translate }}
        </span>
    </div>
    <hr class="line-h-blue-purple-dialogs">
</div>
<div class="modal-body m-3 w-95-p h-80-p scroll-panel">
    <!--Coments-->
    <div class="row">
        <div class="col-12">
            <mat-form-field appearance="outline" class="d-block"
                [ngClass]="(localDataRegister?.comments)?'has-value':''">
                <mat-label>
                    {{ 'rollCall.lblComments' | translate}}
                </mat-label>
                <textarea matInput maxlength="255"
                    [disabled]="true">{{(localDataRegister?.comments) ? localDataRegister?.comments : 'rollCall.lblNotComments' | translate }}</textarea>
            </mat-form-field>
        </div>
    </div>

    <!--Documents-->
    <div class="row mb-3">
        <div class="col-md-5">
            <span class="fw-bold title-modal-detail fz-14-px">
                {{ 'rollCall.lblDocuments' | translate }}
            </span>
            <hr class="line-h-blue-purple-dialogs" style="width: 70%;">
        </div>


        <ng-container *ngIf="localDataRegister.document">
            <div class="col-md-8 mb-3">
                <div class="fileContent">
                    <div class="fileName">
                        Document
                    </div>
                    <div class="fileAction">
                        <button type="button" class="btn-none mr-10-px ml-10-px inline mt-8-px"
                            (click)="onViewFile('document')">
                            <mat-icon>remove_red_eye</mat-icon>
                        </button>
                        <button type="button" class="btn-none mr-10-px ml-10-px" (click)="onDownloadFile('document')">
                            <mat-icon>download</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="localDataRegister.evidence">
            <div class="col-md-8 mb-3">
                <div class="fileContent">
                    <div class="fileName">
                        Evidencia
                    </div>
                    <div class="fileAction">
                        <button type="button" class="btn-none mr-10-px ml-10-px inline mt-8-px"
                            (click)="onViewFile('evidence')">
                            <mat-icon>remove_red_eye</mat-icon>
                        </button>
                        <button type="button" class="btn-none mr-10-px ml-10-px" (click)="onDownloadFile('evidence')">
                            <mat-icon>download</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="localDataRegister.face">
            <div class="col-md-8">
                <div class="fileContent">
                    <div class="fileName">
                        Face
                    </div>
                    <div class="fileAction">
                        <button type="button" class="btn-none mr-10-px ml-10-px inline mt-8-px"
                            (click)="onViewFile('selfie')">
                            <mat-icon>remove_red_eye</mat-icon>
                        </button>
                        <button type="button" class="btn-none mr-10-px ml-10-px" (click)="onDownloadFile('selfie')">
                            <mat-icon>download</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>


    </div>

    <!--Validations-->
    <div class="row mb-3 ">
        <div class="col-md-5">
            <span class="fw-bold title-modal-detail fz-14-px">
                {{ 'rollCall.validations.lblValidations' | translate }}
            </span>
            <hr class="line-h-blue-purple-dialogs" style="width: 70%;">
        </div>
        <ng-container *ngIf="localDataRegister?.validation && localDataRegister?.validation.length > 0">
            <div class="col-md-12 mb-3" *ngFor="let validation of localDataRegister.validation">
                <div class="fileContent">
                    <div class="fileName">
                        {{ (validation.type == 'liveness.face'? 'rollCall.validations.liveness': validation.type ==
                        'match.face'?
                        'rollCall.validations.match' : 'rollCall.validations.location') | translate}}
                    </div>
                    <div class="fileAction_validations">

                        <div class="filterAction__validations__info">
                            <div class="fileAction_validations_container">
                                <img src="assets/icons/{{validation.status == 'success'? 'ico_verified.svg': validation.status == 'wrong' || validation.status == 'failed'? 'ico_wrong.svg': 'ico_reloj.svg'}}"
                                    alt="" srcset="">
                            </div>

                            <ng-container *ngIf="validation.status == 'failed'">
                                <div class="fileAction_validations_container">
                                    <span>{{validation.detail | translate}}</span>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="validation.status !== 'failed'">
                                <div class="fileAction_validations_container">
                                    <span>{{validation.detail | translate}}</span>
                                </div>
                            </ng-container>
                        </div>

                        <div class="fileAction_validations_container">
                            <ng-container *ngIf="validation.status == 'failed'">
                                <button type="button" class="btn btn-primary" (click)="onValidateManual(validation)">
                                    <mat-icon>check_circle</mat-icon> Validar
                                </button>
                            </ng-container>
                        </div>

                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <!--Mapas-->
    <ng-container *ngIf="localDataRegister.source != 'provider'">
        <ng-container *ngIf="!localDataRegister?.locationWrong">
            <div class="row ">
                <div class="col-md-5">
                    <span class="fw-bold title-modal-detail fz-14-px">
                        {{ 'rollCall.geolocation.lblGeolocation' | translate }}
                    </span>
                    <hr class="line-h-blue-purple-dialogs" style="width: 70%;">
                </div>
                <ng-container *ngIf="localDataRegister?.geolocation">
                    <div class="col-md-12">
                        <emi-map [name]="localDataRegister.name" [lat]="localDataRegister.geolocation.latitude"
                            [long]="localDataRegister.geolocation.longitude"></emi-map>
                    </div>
                </ng-container>
                <ng-container *ngIf="!localDataRegister?.geolocation">
                    <div class="col-md-12">
                        <div class="flex justify-content-center align-items-center h-100-p">
                            <span class="fw-bold fz-14-px">
                                {{ 'rollCall.geolocation.lblNotGeolocation' | translate }}
                            </span>
                        </div>
                    </div>
                </ng-container>

            </div>
        </ng-container>
        <ng-container *ngIf="localDataRegister?.locationWrong">
            <div class="row ">
                <div class="col-md-5">
                    <span class="fw-bold title-modal-detail fz-14-px">
                        {{ 'rollCall.geolocation.lblGeolocation' | translate }}
                    </span>
                    <hr class="line-h-blue-purple-dialogs" style="width: 70%;">
                </div>
                <!--<ng-container *ngIf="!localDataRegister?.geolocation">
                    <div class="col-md-12">
                        <div class="flex justify-content-center align-items-center h-100-p">
                            <span class="fw-bold fz-14-px">
                                {{ 'rollCall.geolocation.lblNotGeolocation' | translate }}
                            </span>
                        </div>
                    </div>
                </ng-container>-->
            </div>

            <div class="row">
                <div class="col-md-6">
                    <ng-container *ngIf="localDataRegister?.locationWrong">
                        <emi-map [name]="'Punto de origen'" [id]="'mapSource'"
                            [lat]="localDataRegister.locationWrong.sourceGeolocation.latitude"
                            [long]="localDataRegister.locationWrong.sourceGeolocation.longitude"></emi-map>
                    </ng-container>
                </div>
                <div class="col-md-6">
                    <ng-container *ngIf="localDataRegister?.locationWrong">
                        <emi-map [name]="'Punto de referencia'" [id]="'mapReference'"
                            [lat]="localDataRegister.locationWrong.referenceGeolocation.latitude"
                            [long]="localDataRegister.locationWrong.referenceGeolocation.longitude"></emi-map>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </ng-container>



</div>
<div class="modal-footer" [ngStyle]="{'position': localDataRegister.source == 'provider' ? 'fixed': 'relative' }">
    <div class="row">
        <div class="col-md-12 d-flex justify-content-end align-items-center">
            <button class="btn btn-secondary" data-dismiss="modal" (click)="onClose()">
                {{'common.btnClose' | translate }}
            </button>
        </div>
    </div>

</div>